module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAXklEQVQ4jWOgBWAEmTlz5sz/1DI7PT2dkQXGKe/4xIihgkTQWcEHdhwLmjZ8LmYkQh4MmDCkqABGDR0ihqInKUJplai0DDe0s4KPYTSdjhpKOaBtOiWQBgcYMDAwAACQ7Q5EZdj9qwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/icon/icon_view_top2.png
// module id = JmMt
// module chunks = 3